// extracted by mini-css-extract-plugin
export var barContainer = "_27-0";
export var extraThin = "_27-3";
export var fillBar = "_27-6";
export var fillContainer = "_27-4";
export var overflow = "_27-8";
export var overflowContainer = "_27-5";
export var regular = "_27-7";
export var thick = "_27-1";
export var thin = "_27-2";